import React, { useState } from 'react';

export default (initialValue = false) => {
  const [isTrue, setIsTrue] = useState(initialValue);

  const toggle = (newState) => {
    if (newState === true || newState === false) {
      setIsTrue(newState);
    } else {
      setIsTrue((prev) => !prev);
    }
  };

  return [isTrue, toggle];
};
